import React from 'react';
import { Modal, Button } from 'semantic-ui-react';

const CancelModal = ({ open, onConfirm, onClose }) => {
	return (
		<Modal open={open} onClose={onClose} size='tiny'>
			<Modal.Header>Confirm Cancel</Modal.Header>
			<Modal.Content>
				If you cancel now your information<b> will not </b>
				be saved. Would you like to cancel?
			</Modal.Content>
			<Modal.Actions>
				<Button id="yesBtn" primary onClick={onConfirm}>Yes</Button>
				<Button id="noBtn" primary onClick={onClose}>No</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default CancelModal;
